"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AMMAlgorithmMapping = exports.AMMAlgorithmType = exports.BlacklistWrapper = exports.Wrapper = exports.RetroWrapper = exports.SushiSwapV3Wrapper = exports.UniswapV3Wrapper = exports.AMMType = exports.isMerklSupportedChainId = void 0;
const _1 = require(".");
const MerklSupportedChainIds = [_1.ChainId.ARBITRUM, _1.ChainId.MAINNET, _1.ChainId.OPTIMISM, _1.ChainId.POLYGON, _1.ChainId.POLYGONZKEVM];
const isMerklSupportedChainId = (chainId) => {
    return MerklSupportedChainIds.includes(chainId);
};
exports.isMerklSupportedChainId = isMerklSupportedChainId;
var AMMType;
(function (AMMType) {
    AMMType[AMMType["UniswapV3"] = 0] = "UniswapV3";
    AMMType[AMMType["SushiSwapV3"] = 1] = "SushiSwapV3";
    AMMType[AMMType["Retro"] = 2] = "Retro";
    AMMType[AMMType["PancakeSwap"] = 3] = "PancakeSwap";
})(AMMType = exports.AMMType || (exports.AMMType = {}));
var UniswapV3Wrapper;
(function (UniswapV3Wrapper) {
    UniswapV3Wrapper[UniswapV3Wrapper["Arrakis"] = 0] = "Arrakis";
    UniswapV3Wrapper[UniswapV3Wrapper["Gamma"] = 2] = "Gamma";
    UniswapV3Wrapper[UniswapV3Wrapper["DefiEdge"] = 4] = "DefiEdge";
    UniswapV3Wrapper[UniswapV3Wrapper["Ichi"] = 5] = "Ichi";
    UniswapV3Wrapper[UniswapV3Wrapper["Steer"] = 6] = "Steer";
})(UniswapV3Wrapper = exports.UniswapV3Wrapper || (exports.UniswapV3Wrapper = {}));
var SushiSwapV3Wrapper;
(function (SushiSwapV3Wrapper) {
    SushiSwapV3Wrapper[SushiSwapV3Wrapper["Gamma"] = 2] = "Gamma";
    SushiSwapV3Wrapper[SushiSwapV3Wrapper["DefiEdge"] = 4] = "DefiEdge";
    SushiSwapV3Wrapper[SushiSwapV3Wrapper["Steer"] = 6] = "Steer";
})(SushiSwapV3Wrapper = exports.SushiSwapV3Wrapper || (exports.SushiSwapV3Wrapper = {}));
var RetroWrapper;
(function (RetroWrapper) {
    RetroWrapper[RetroWrapper["Gamma"] = 2] = "Gamma";
    RetroWrapper[RetroWrapper["Ichi"] = 5] = "Ichi";
})(RetroWrapper = exports.RetroWrapper || (exports.RetroWrapper = {}));
exports.Wrapper = {
    [AMMType.UniswapV3]: UniswapV3Wrapper,
    [AMMType.SushiSwapV3]: SushiSwapV3Wrapper,
    [AMMType.Retro]: RetroWrapper,
    [AMMType.PancakeSwap]: null,
};
var BlacklistWrapper;
(function (BlacklistWrapper) {
    BlacklistWrapper[BlacklistWrapper["Blacklist"] = 3] = "Blacklist";
})(BlacklistWrapper = exports.BlacklistWrapper || (exports.BlacklistWrapper = {}));
var AMMAlgorithmType;
(function (AMMAlgorithmType) {
    AMMAlgorithmType[AMMAlgorithmType["UniswapV3"] = 0] = "UniswapV3";
})(AMMAlgorithmType = exports.AMMAlgorithmType || (exports.AMMAlgorithmType = {}));
exports.AMMAlgorithmMapping = {
    [AMMType.UniswapV3]: AMMAlgorithmType.UniswapV3,
    [AMMType.SushiSwapV3]: AMMAlgorithmType.UniswapV3,
    [AMMType.Retro]: AMMAlgorithmType.UniswapV3,
    [AMMType.PancakeSwap]: AMMAlgorithmType.UniswapV3,
};
//# sourceMappingURL=merkl.js.map